<div class="modal-module-wrapper">
  <div class="container padding--none">
    <div class="grid-row modal-module">
      <div class="xs-12">
        <h2>What about {{ upsellItems | lowercase }}?</h2>
        <p class="modal-module__content">
          We’ve noticed that you haven’t selected
          {{
            upsellItems
              ? (upsellItems.replace(' and ', ' or ') | lowercase)
              : ('' | lowercase)
          }}.

          {{
            isSingular
              ? 'This isn’t automatically included. Therefore, if you want us to take care of it you’ll need to add this.'
              : 'These aren’t automatically included. Therefore, if you want us to take care of it you’ll need to add them.'
          }}
        </p>
        <div class="grid-row modal-module__cta-group">
          <div class="modal-module__cta xs-12 md-6">
            <dgx-components-button variant="primary" (clicked)="onClick(true)"
              >Add {{ upsellItems | lowercase }}</dgx-components-button
            >
          </div>
          <div class="modal-module__cta xs-12 md-6">
            <dgx-components-button
              variant="secondary"
              (clicked)="onClick(false)"
              >Continue without
              {{ upsellItems | lowercase }}</dgx-components-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
